import { css } from '@emotion/css';

import { cn } from '@lyearn/style';

const taskSidebarPillStyles = css`
  :active {
    background-color: var(--gray-200);
  }
`;

const br6 = css`
  border-radius: 0.6rem;
`;

export const baseButtonFocusStyles = css`
  &.Mui-focusVisible {
    box-shadow: 0 0 0 0.16rem var(--focus-secondary);
  }
`;

export const TASK_PILL_VARIANT_CONFIG = {
  sidebar: {
    root: { className: '' },
    rootEditable: { className: cn(taskSidebarPillStyles, 'rounded-8 hover:bg-bg-hover') },
    label: { className: 'truncate', color: 'text-text-primary' as const },
    icon: { fillColorToken: 'icon-primary' },
    popoverPosition: 'bottom-end' as const,
  },
  modal: {
    root: { className: cn(br6, 'border border-solid border-border') },
    rootEditable: { className: 'hover:bg-bg-hover active:bg-bg-onclick' },
    label: { className: 'truncate', color: 'text-text-secondary' as const },
    icon: { fillColorToken: 'icon-secondary' },
    popoverPosition: 'bottom-start' as const,
  },
};

export type TaskPillVariant = 'sidebar' | 'modal';
